import { dNotify } from 'packages/lib/common-ui/notification/deduped-notify';
import {
  TaskQueue,
  TaskQueueParams,
  taskQueue,
} from 'packages/task-man/service/pickup/task-queue';
import { useEffect } from 'react';
import { AnnotationState } from 'packages/lib/api/annotations/contract/enums';
import useSWRImmutable from 'swr/immutable';

export const useTaskQueue = (
  params: Partial<TaskQueueParams> & { annotationState?: AnnotationState }
) => {
  const swr = useSWRImmutable(params, (maybeParams: Partial<TaskQueueParams>) =>
    !isTaskQueueParams(maybeParams) ? undefined : taskQueue(maybeParams)
  );

  const { error } = swr;
  useEffect(() => {
    if (error) {
      dNotify.error({
        message: `There was an error when fetching Task Queue data: ${error.message}`,
      });
    }
  }, [error, params]);
  return swr;
};

/** Builds a string-based key for useSWR. Not a URL, just used for cache-identifying purposes. */
export const swrKey = (
  taskQueue: TaskQueue,
  multitaskBatchID: number,
  name: string
) => {
  const { role, userEmail, sampleGroup, taskGroupType } = taskQueue;
  return `task-queue/${name}/${sampleGroup.token}/${taskGroupType}/${role}/${userEmail}/${multitaskBatchID}`;
};

const isTaskQueueParams = (
  maybeParams: Partial<TaskQueueParams>
): maybeParams is TaskQueueParams => {
  return !!(
    maybeParams.role &&
    maybeParams.sampleGroupToken &&
    maybeParams.userEmail &&
    maybeParams.taskGroupType
  );
};
